import React from "react";

function ScannerIcon() {
  return (
    <svg
      fill="#000000"
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      id="scan"
      data-name="Flat Color"
      xmlns="http://www.w3.org/2000/svg"
      className="icon flat-color"
    >
      <path
        id="secondary"
        d="M21,13H3a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z"
        style={{ fill: "rgb(44, 169, 188)" }}
      />
      <path
        id="primary"
        d="M3,8A1,1,0,0,1,2,7V4A2,2,0,0,1,4,2H7A1,1,0,0,1,7,4H4V7A1,1,0,0,1,3,8ZM22,7V4a2,2,0,0,0-2-2H17a1,1,0,0,0,0,2h3V7a1,1,0,0,0,2,0ZM8,21a1,1,0,0,0-1-1H4V17a1,1,0,0,0-2,0v3a2,2,0,0,0,2,2H7A1,1,0,0,0,8,21Zm14-1V17a1,1,0,0,0-2,0v3H17a1,1,0,0,0,0,2h3A2,2,0,0,0,22,20Z"
        style={{ fill: "rgb(0, 0, 0)" }}
      />
    </svg>
  );
}

export default ScannerIcon;
